import React from "react";

export interface ErrorCardProps {
  title?: string;
  message: string;
  subtitle?: string;
}

export function ErrorCard({ title = "Failed to load", message, subtitle }: ErrorCardProps) {
  return (
    <div className="mc-slot p-6 bg-destructive/15 text-destructive">
      {title && <p className="uppercase mb-2">{title}</p>}
      <p className="text-sm">{message}</p>
      {subtitle && <p className="text-xs mt-2 opacity-70">{subtitle}</p>}
    </div>
  );
}
